export default __webpack_public_path__ + "static/media/empty-cookbook.9ade6ddc.svg";